import React, { FC } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../icon/Icon';
import './InUseBanner.scss';

export interface IInUseBannerProps {
	message: string;
	className?: string;
}

/** Top-of-form note when a master record is already used in production. */
const InUseBanner: FC<IInUseBannerProps> = ({ message, className }) => (
	<div className={`in-use-banner ${className}`.trim()} role='status'>
		<Icon icon='InfoOutline' size='sm' className='in-use-banner__icon' />
		<span className='in-use-banner__text'>{message}</span>
	</div>
);

InUseBanner.propTypes = {
	message: PropTypes.string.isRequired,
	className: PropTypes.string,
};
InUseBanner.defaultProps = {
	className: '',
};

export { InUseBanner };
export default InUseBanner;
